<app-modal-dialog
  [show]="showGroupedModal"
  (closed)="close(modal)"
  size="auto"
  position="top"
  #modal
>
  <!-- Encabezado -->
  <div class="modal-header" modal-header>
    <div class="d-flex align-items-center justify-content-between w-100">
      <h3 class="m-0">
        <i class="fa fa-layer-group me-2"></i>
        Detalle de Reservaciones Agrupadas
      </h3>
      <i class="fa fa-xmark i-hover" (click)="close(modal)"></i>
    </div>
  </div>

  <!-- Cuerpo del modal -->
  <div class="modal-body" modal-body>
    <!-- Loading -->
    <div *ngIf="groupedLoading" class="text-center my-4">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Cargando...</span>
      </div>
    </div>

    <!-- Contenido principal -->
    <div *ngIf="!groupedLoading && groupedReservations?.length > 0">
      <ng-container *ngFor="let group of groupedReservations; let gi = index">
        <div>
          <!-- Header de la agrupación -->
          <div class="card-header text-white d-flex justify-content-between align-items-center">
            <h5 class="m-0">
              <i class="fa fa-warehouse me-2"></i>
              {{
                group.orderReservations[0]?.warehouseData?.name
                  || ('Bodega ID: ' + (group.warehouseId || 'N/A'))
              }}
            </h5>
            <span class="badge bg-info px-3">Reservado</span>
          </div>

          <!-- Body -->
          <div class="card-body">
            <h6 class="text-muted mb-2">
              <i class="fa fa-file-alt me-1"></i> Reservaciones Asociadas
            </h6>
            <table class="table table-sm table-bordered mb-3">
              <thead class="table-light">
                <tr>
                  <th>#</th>
                  <th>Número</th>
                  <th>Cliente</th>
                  <th>Fecha Reserva</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let order of group.orderReservations; let oi = index">
                  <td>{{ oi + 1 }}</td>
                  <td>{{ order.number }}</td>
                  <td>{{ order.clientData?.name || 'Sin cliente' }}</td>
                  <td>{{ order.reservedDate | date: 'yyyy/MM/dd' }}</td>
                </tr>
              </tbody>
            </table>

            <hr />

            <!-- Productos agrupados -->
            <h6 class="text-muted mb-2">
              <i class="fa fa-boxes-stacked me-1"></i> Productos Reservados
            </h6>

            <div class="table-responsive">
              <table class="table table-striped table-sm align-middle">
                <thead class="table-light">
                  <tr>
                    <th>#</th>
                    <th>Producto</th>
                    <th class="ta">Cantidad Total</th>
                    <!-- <th class="ta">Acciones</th> -->
                  </tr>
                </thead>

                <tbody>
                  <ng-container *ngFor="let prod of group.orderReservationProducts; let pi = index">
                    <!-- Fila principal -->
                    <tr>
                      <td>{{ pi + 1 }}</td>
                      <td>
                        {{ prod.product?.name || '-' }}
                        <button
                          class="btn btn-sm btn-link text-primary"
                          (click)="toggleBreakdown(prod, group)"
                        >
                          <i
                            class="fa"
                            [ngClass]="{
                              'fa-chevron-down': !prod.showBreakdown,
                              'fa-chevron-up': prod.showBreakdown
                            }"
                          ></i>
                          Seleccionar Traslado
                        </button>

                      </td>
                      <td class="ta">{{ prod.quantity }}</td>
                      <!-- <td class="ta">
                        <button
                          class="btn btn-sm btn-outline-primary"
                          (click)="toggleBreakdown(prod, group)"
                        >
                          <i
                            class="fa"
                            [ngClass]="{
                              'fa-chevron-down': !prod.showBreakdown,
                              'fa-chevron-up': prod.showBreakdown
                            }"
                          ></i>
                          Ver bodegas
                        </button>
                      </td> -->
                    </tr>

                    <!-- Breakdown (existencias por bodega) -->
                    <tr *ngIf="prod.showBreakdown">
                      <td colspan="4">
                        <div *ngIf="prod.loadingExistence" class="text-center my-2">
                          <div class="spinner-border text-primary" role="status"></div>
                        </div>

                        <div *ngIf="!prod.loadingExistence && prod.warehouseExistence">
                          <table class="table table-bordered table-sm mb-0">
                            <thead class="table-light">
                              <tr>
                                <th>Bodega</th>
                                <th class="ta">Existencia</th>
                                <th class="ta">Cantidad a pasar</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let w of prod.warehouseExistence">
                                <td>{{ w.warehouseName }}</td>
                                <td class="ta">{{ w.existence }}</td>
                                <td class="ta">
                                  <input
                                    type="number"
                                    class="form-control form-control-sm text-end"
                                    [(ngModel)]="w.transferQuantity"
                                    [max]="w.existence"
                                    min="0"
                                    (input)="validateTransferQuantity(prod, w)"
                                  />
                                </td>
                              </tr>
                            </tbody>
                            <tfoot class="fw-bold bg-light">
                              <tr>
                                <td colspan="2" class="text-end">Total a enviar:</td>
                                <td class="ta">{{ getTotalTransferQuantity(prod) }}</td>
                              </tr>
                            </tfoot>
                          </table>
                        </div>
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <!-- Sin resultados -->
    <div
      *ngIf="!groupedLoading && (!groupedReservations || groupedReservations.length === 0)"
      class="text-center text-muted py-4"
    >
      <i class="fa fa-circle-info"></i> No se encontraron reservaciones agrupadas.
    </div>
    <div
      class="text-end mt-3"
      *ngIf="!groupedLoading && groupedReservations?.length > 0"
    >
      <button class="btn btn-success px-4" (click)="confirmGroupedTransfer()">
        <i class="fa fa-truck me-1"></i> Despachar Agrupado
      </button>
    </div>
  </div>
</app-modal-dialog>
